import { render, staticRenderFns } from "./FamilyHistoryCN.vue?vue&type=template&id=44d184c5"
import script from "./FamilyHistoryCN.vue?vue&type=script&lang=js"
export * from "./FamilyHistoryCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports